var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "ibox sombra-light" }, [
          _c("div", { staticClass: "ibox-title pb-3" }, [
            _c("h5", [
              _vm._v("\r\n                    Pruebas\r\n                "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ibox-tools" }, [
              _c(
                "button",
                { staticClass: "btn btn-primary", on: { click: _vm.crear } },
                [_vm._v("Crear")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ibox-content" },
            [
              _c("data-table", {
                attrs: {
                  id: _vm.dt.id,
                  datos: _vm.dt.datos,
                  columnas: _vm.dt.columnas,
                  responsive: true,
                  "font-size": 12,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("Modal", {
        ref: "Modal",
        attrs: {
          canales: _vm.canales,
          vouchers: _vm.vouchers,
          tipo_citas: _vm.tipo_citas,
          servicios: _vm.servicios,
          establecimientos: _vm.establecimientos,
        },
        on: { guardar: _vm.guardar },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }